var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header',{attrs:{"icon":"fad fa-satellite","title":"Druhy spotřebičů"},scopedSlots:_vm._u([{key:"buttons",fn:function(){return [_c('PrimaryLinkButton',{attrs:{"to":"/setup/appliance_types/create","icon":"fad fa-plus-circle","text":"Přidat druh spotřebiče"}})]},proxy:true}])}),_c('ApplianceTypesList')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }